import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../images/logo_biojeck.png";
import {
  FaUser,
  FaFileInvoice,
  FaFileContract,
  FaTachometerAlt,
  FaSearchengin
} from "react-icons/fa";
import "./Home.css";

const Home = () => {
  const ROLE = JSON.parse(localStorage.getItem("user"))[0].role;
  const WELCOME = `Bienvenido ${
    JSON.parse(localStorage.getItem("user"))[0].name
  } ${JSON.parse(localStorage.getItem("user"))[0].surname}`;

  return (
    <div className=" justify-content-center align-items-center min-vh-100 home">
      <div className="banner-container">
        <h1 className="welcome">{WELCOME}</h1>
        <img src={Logo} alt="Biojeck Logo" className="banner" />
      </div>
      <div className="cards">
        {ROLE === "administrador" && (
          <>
            <div className="card">
              <div className="icon-container">
                <FaUser className="icon-home" />
              </div>
              <h2>Empleados</h2>
              <p>Gestión de empleados de la empresa.</p>
              <Link to="/employes">Ir al Módulo</Link>
            </div>
            <div className="card">
              <div className="icon-container">
                <FaTachometerAlt className="icon-home" />
              </div>
              <h2>Panel de control</h2>
              <p>Gestión de insumos y planes de la empresa.</p>
              <Link to="/control-panel">Ir al Módulo</Link>
            </div>
          </>
        )}
        <div className="card">
          <div className="icon-container">
            <FaFileInvoice className="icon-home" />
          </div>
          <h2>Facturas</h2>
          <p>Gestión de facturas y pagos.</p>
          <Link to="/invoices">Ir al Módulo</Link>
        </div>
        {(ROLE === "apoyo administrativo" || ROLE === "administrador") && (
          <>
            <div className="card">
              <div className="icon-container">
                <FaFileContract className="icon-home" />
              </div>
              <h2>Contratos</h2>
              <p>Gestión de contratos.</p>
              <Link to="/contracts">Ir al Módulo</Link>
            </div>
            <div className="card">
              <div className="icon-container">
                <FaSearchengin className="icon-home" />
              </div>
              <h2>Consultar facturas</h2>
              <p>Consulta general y especifica de las facturas.</p>
              <Link to="/consult-invoices">Ir al Módulo</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Home;
